import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';

export function useLocalStorageState<S>(keyName: string, defaultValue: S): [S, Dispatch<SetStateAction<S>>] {
    const [storedValue, setStoredValue] = React.useState<S>(() => {
        try {
            const value = window.localStorage.getItem(keyName);

            if (value) {
                return JSON.parse(value);
            } else {
                window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
                return defaultValue;
            }
        } catch (err) {
            return defaultValue;
        }
    });

    React.useEffect(() => {
        try {
            window.localStorage.setItem(keyName, JSON.stringify(storedValue));
        } catch (err) {
            /** silent error */
        }
    }, [keyName, storedValue]);

    return [storedValue, setStoredValue];
}
